<template>
  <div class="view-profile-settings">
    <view-profile-avatar
      class="view-profile-settings__avatar"
    ></view-profile-avatar>
    <div class="view-profile-settings__form">
      <app-title-box
        is-tooltip
        tooltip="Ваши данные профиля."
        title="Контактные данные"
        class="view-profile-settings__title"
      ></app-title-box>

      <div class="view-profile-settings__field-group">
        <div class="app-input-group">
          <app-input-control
            placeholder="Ваше имя"
            title="Ваше имя"
            tooltip="Имя, указанное в профиле, доступно для редактирования."
            v-model="currentFirstName"
            @blur="submitSettingsProfile"
          ></app-input-control>
          <small
            v-if="$v.currentFirstName.$dirty && $v.currentFirstName.$error"
            class="app-input-group__invalid"
          >
            Введите корректное имя
          </small>
        </div>
      </div>

      <div class="view-profile-settings__field-group">
        <div class="app-input-group">
          <app-input-control
            placeholder="Ваша фамилия"
            title="Ваша фамилия"
            tooltip="Фамилия, указанная в профиле, доступна для редактирования."
            v-model="currentLastName"
            @blur="submitSettingsProfile"
          ></app-input-control>
          <small
            v-if="$v.currentLastName.$dirty && $v.currentLastName.$error"
            class="app-input-group__invalid"
          >
            Введите корректную фамилию
          </small>
        </div>
      </div>

      <div class="view-profile-settings__field-group">
        <div class="app-input-group">
          <app-input-control
            placeholder="Ваше отчество"
            title="Ваше отчество"
            tooltip="Отчество, указанное в профиле, доступно для редактирования."
            v-model="currentMiddleName"
            @blur="submitSettingsProfile"
          ></app-input-control>
          <small
            v-if="$v.currentMiddleName.$dirty && $v.currentMiddleName.$error"
            class="app-input-group__invalid"
          >
            Введите корректное отчество
          </small>
        </div>
      </div>

      <div class="view-profile-settings__field-group">
        <div class="app-input-group">
          <app-input-control
            type="phone"
            placeholder="9000000000"
            title="Телефон"
            tooltip="Ваш номер телефона. Доступен для редактирования."
            v-model="currentPhone"
            @blur="submitSettingsProfile"
          ></app-input-control>
          <small
            v-if="$v.currentPhone.$dirty && $v.currentPhone.$error"
            class="app-input-group__invalid"
          >
            Введите корректный телефон
          </small>
        </div>
      </div>

      <div
        class="view-profile-settings__field-group view-profile-settings__field-group--cols view-profile-settings__field-group--email"
      >
        <div class="view-profile-settings__field-group-input">
          <div class="app-input-group">
            <app-input-control
              type="email"
              placeholder="example@gmail.com"
              title="Email"
              tooltip="Адрес почты, на который оформлен аккаунт. Не доступен для редактирования."
              v-model="currentEmail"
              :isReadonly="isEmail"
            ></app-input-control>
            <small
              v-if="$v.currentEmail.$dirty && $v.currentEmail.$error"
              class="app-input-group__invalid"
            >
              Введите корректный email
            </small>
          </div>
        </div>
        <app-button-control
          type="link"
          @click="submitUpdateEmail"
          v-if="!isEmail"
        >
          Сохранить email
        </app-button-control>
      </div>

      <app-title-box
        is-tooltip
        tooltip="Параметры авторизации пользователя."
        title="Параметры входа"
        class="view-profile-settings__title"
      ></app-title-box>

      <div
        class="view-profile-settings__field-group view-profile-settings__field-group--cols view-profile-settings__field-group--password"
      >
        <div class="view-profile-settings__field-group-input">
          <app-input-control
            type="password"
            title="Пароль"
            value="password"
            isReadonly
            :isIcon="false"
          ></app-input-control>
        </div>

        <app-button-control type="link" @click="openPasswordCurtain">
          Изменить пароль
        </app-button-control>
      </div>

      <view-profile-connect-providers
        class="view-profile-settings__connectors view-profile-settings__field-group"
        :providers="(profile && profile.connections) || {}"
      ></view-profile-connect-providers>

      <app-title-box
        is-tooltip
        tooltip="Восстановить аккаунт с сохранением данных можно в течение 30 дней после удаления"
        title="Удалить аккаунт"
        class="view-profile-settings__title"
      ></app-title-box>
      <view-profile-remove-account
        class="view-profile-settings__field-group"
      ></view-profile-remove-account>

      <template v-if="$development">
        <app-toggler
          title="Вход по одноразовому коду"
          tooltip="Подсказка"
          id="t1"
          name="Вход по одноразовому коду"
          class="profile-toggler view-profile-settings__field-group"
        />
        <app-toggler
          title="SMS уведомление"
          tooltip="Подсказка"
          id="t2"
          name="SMS уведомление"
          class="profile-toggler view-profile-settings__field-group"
        />
        <app-toggler
          title="Сбербанк ID"
          tooltip="Подсказка"
          id="t3"
          name="Сбербанк ID"
          image="sber"
          class="profile-toggler view-profile-settings__field-group"
        />
      </template>

      <app-setting-for-test v-if="isMainTestAccount"></app-setting-for-test>
    </div>
    <div v-if="!isSeller" class="view-profile-settings__table">
      <app-title-box
        is-tooltip
        tooltip="Список ваших юридических лиц, прикрепленных к профилю пользователя."
        title="Мои организации"
        class="view-profile-index__title"
      ></app-title-box>

      <contractors-table
        v-if="!isLoading && contractorsList.length > 0"
        :sort="sort"
        :isAllClose="isAllClose"
        @changeSort="changeSort"
        @open-edit="isOpenContractorEdit"
        :list="contractorsList"
      ></contractors-table>
      <app-button-control
        v-if="!isLoading"
        type="secondary"
        @click="isOpenContractorAdd"
        isCapitalize
      >
        добавить организацию
      </app-button-control>
    </div>
    <app-curtain-change-password
      v-if="isCurtainChangePass"
      :isPortal="isCurtainChangePass"
    ></app-curtain-change-password>

    <contractor-form
      :idEditContractor="idEditContractor"
      :isEdit="isEdit"
      :isPortal="isContractorForm"
      v-if="isContractorForm"
      @loading="isLoading = $event"
      @open-edit="isOpenContractorEdit($event)"
    ></contractor-form>

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>
<script>
import { rootMapper } from '@/store/root';
import { authMapper } from '@/store/auth';
import { contractorsMapper } from '@/store/contractors';
import { alphaAllnum } from '@/helpers/validators';
import {
  required,
  minLength,
  email as emailValidator,
} from 'vuelidate/lib/validators';

export default {
  name: 'ViewProfileSettings',
  validations: {
    currentEmail: {
      emailValidator,
    },
    currentFirstName: { alphaAllnum, required },
    currentMiddleName: { alphaAllnum },
    currentLastName: { alphaAllnum },
    currentPhone: { minLength: minLength(18) },
    validationGroup: [
      'currentEmail',
      'currentFirstName',
      'currentMiddleName',
      'currentLastName',
      'currentPhone',
    ],
  },
  components: {
    AppCurtainChangePassword: () =>
      import('@/components/curtains/AppCurtainChangePassword'),
    AppSettingForTest: () => import('@/components/common/AppSettingForTest'),
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
    AppToggler: () => import('@/components/common/AppToggler'),
    AppInputControl: () => import('@/components/ui/AppInputControl'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    ContractorsTable: () =>
      import(
        '@/pages/contractors/components/contractors-table/ContractorsTable'
      ),
    ContractorForm: () =>
      import('@/pages/contractors/components/ContractorForm'),
    AppLoader: () => import('@/components/ui/AppLoader'),
    ViewProfileAvatar: () =>
      import('@/pages/profile/components/ViewProfileAvatar'),
    ViewProfileConnectProviders: () =>
      import('@/pages/profile/components/ViewProfileConnectProviders'),
    ViewProfileRemoveAccount: () =>
      import('@/pages/profile/components/ViewProfileRemoveAccount'),
  },

  data: () => ({
    currentFirstName: '',
    currentLastName: '',
    currentMiddleName: '',
    currentName: '',
    currentPhone: '',
    currentEmail: '',
    isLoading: false,
    isLoadingSettings: false,
    isCurtainChangePass: false,
    isContractorForm: false,
    isEdit: false,
    idEditContractor: 0,
    sort: {
      field: 'name',
      order: 'asc',
    },
    isAllClose: false,
  }),
  computed: {
    ...authMapper.mapState(['profile', 'userEmailForTest']),
    ...contractorsMapper.mapGetters(['contractorsList']),
    ...rootMapper.mapState(['isOpenedCurtain']),
    ...authMapper.mapGetters(['isEmail', 'isMainTestAccount', 'isSeller']),
  },
  watch: {
    isOpenedCurtain(value) {
      if (!value) {
        this.isCurtainChangePass = false;
        this.isContractorForm = false;
      }
    },
    userEmailForTest(value) {
      if (this.isMainTestAccount) {
        this.currentEmail = value;
      }
    },
  },
  created() {
    const {
      firstName,
      lastName,
      middleName,
      name,
      phone,
      email,
    } = this.profile;
    this.currentFirstName = firstName;
    this.currentLastName = lastName;
    this.currentMiddleName = middleName;
    this.currentName = name;
    this.currentPhone = phone;
    this.currentEmail = email;
  },
  methods: {
    ...authMapper.mapActions(['updateProfile']),
    ...authMapper.mapMutations(['SET_USER_EMAIL_FOR_TEST']),
    ...contractorsMapper.mapActions(['getContractors']),
    /**
     * Обновление почты
     */
    submitUpdateEmail() {
      if (this.isMainTestAccount) {
        this.SET_USER_EMAIL_FOR_TEST(this.currentEmail);
        return false;
      }

      this.submitSettingsProfile();
      return false;
    },
    /**
     * Смена сортировки
     */
    async changeSort(event) {
      this.sort = event;
      try {
        this.isAllClose = true;
        await this.getContractors({ sort: this.sort });
      } catch (error) {
        // -
      } finally {
        this.isAllClose = false;
      }
    },
    /**
     * Открытие шторки редактирования контрагента
     * @param {Number} id - id контрагента
     */
    isOpenContractorEdit(id) {
      this.idEditContractor = id;
      this.isEdit = true;
      this.isContractorForm = true;
      this.$modal.show('main-curtain');
    },
    /**
     * Открытие шторки создания контрагента
     */
    isOpenContractorAdd() {
      this.isEdit = false;
      this.isContractorForm = true;
      this.$modal.show('main-curtain');
    },
    /**
     * Открытие шторки смены пароля
     */
    openPasswordCurtain() {
      this.isCurtainChangePass = true;
      this.$modal.show('main-curtain');
    },
    /**
     * Смена настроек профиля
     * TODO: возможно будет отдельное апи на добавление имейла или отправлять имейл будем только если его не было
     */
    async submitSettingsProfile() {
      if (this.$v.validationGroup.$invalid) {
        this.$v.$touch();
        return;
      }
      if (
        this.currentFirstName === this.profile.firstName &&
        this.currentLastName === this.profile.lastName &&
        this.currentEmail === this.profile.email &&
        this.currentMiddleName === this.profile.middleName &&
        this.$options.filters.VMask(this.currentPhone, '###########') ===
          this.profile.phone
      ) {
        return;
      }
      const formData = {
        firstName: this.currentFirstName,
        lastName: this.currentLastName,
        middleName: this.currentMiddleName,
        phone: this.$options.filters.VMask(this.currentPhone, '###########'),
      };
      if (!this.profile.email) {
        formData.email = this.currentEmail;
      }
      this.isLoadingSettings = true;
      try {
        await this.updateProfile(formData);
      } catch {
        //
      } finally {
        this.isLoadingSettings = false;
      }
    },
  },
};
</script>
<style lang="scss">
.view-profile-settings {
  $root: &;

  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;

  @include media-sm() {
    flex-direction: column;
  }

  @include media-xs() {
    padding: 20px;
  }

  &__form {
    flex: 0 0 50%;

    @include media-md() {
      flex: 0 0 65%;
    }

    @include media-sm() {
      flex: 0 0 100%;
      width: 100%;
    }
  }

  &__field-group {
    display: flex;
    margin-bottom: 20px;
  }

  &__field-group--cols {
    justify-content: flex-start;

    @include media-xs() {
      flex-direction: column;
      margin-bottom: 40px;
    }

    #{$root}__field-group-input {
      flex: 0 0 60%;
      margin-right: 20px;

      @include media-xs() {
        flex: 0 0 100%;
        margin-right: 0;
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &__field-group--password {
    margin-bottom: 34px;
  }

  &__field-group--email {
    @include media-xs() {
      margin-bottom: 20px;
    }
  }

  &__field-group-input {
    position: relative;
    width: 100%;
  }

  &__password-complexity {
    position: absolute;
    bottom: -14px;
  }

  &__title {
    margin-bottom: 20px;
  }

  &__table {
    flex: 0 0 100%;
    width: 100%;
    margin: 60px 0 0;
  }

  &__avatar {
    flex: 0 0 20%;
    text-align: center;

    @include media-md() {
      flex: 0 0 35%;
    }

    @include media-sm() {
      flex: 0 0 100%;
      margin: 0 auto 50px;
    }
  }

  &__avatar-btn {
    display: flex;
    align-items: stretch;
    justify-content: center;

    a {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      margin: 0 0 0 -1px;
      text-decoration: none;
      border: 1px solid #e8e8e8;
      border-radius: 2px;

      svg {
        width: 14px;
        height: 14px;
        margin: 0 10px 0 0;
      }

      &.edit {
        font-size: rem(14);
        font-weight: 300;
        color: $color-black;
        letter-spacing: 0.01em;
      }

      &.remove {
        font-family: sans-serif;
        font-size: rem(16);
        font-weight: 600;
        color: #989898;
      }
    }
  }

  &__avatar-img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    margin: 0 auto 20px;
    overflow: hidden;
    border-radius: 120px;

    img {
      width: 100%;
    }
  }

  &__row-body {
    display: flex;
    justify-content: space-between;
  }

  &__list-title {
    min-width: 340px;
  }

  &__list-text {
    margin: 0;
  }

  &__row-body-right {
    display: flex;
    flex-direction: column;
  }

  &__row-body-system {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    text-align: right;
  }

  &__row-body-system-link {
    margin-bottom: 12px;
    font-size: rem(13);
    line-height: 17px;
    color: $color-gray-8;
    text-decoration: none;
    transition: color $A;

    &:hover {
      color: $color-black;
    }
  }

  &__btn {
    margin-right: 13px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  &__table-container {
    width: 100%;
  }
}

.profile {
  &-toggler {
    flex: 0 0 60%;
    width: 60%;

    @include media-xs() {
      flex: 0 0 100%;
      width: 100%;
    }
  }
}

@include media-xs() {
  .view-profile-settings {
    &__table-header {
      display: none !important;
    }

    &__row-header {
      flex-wrap: wrap;
      margin: 0 -15px;
    }
  }

  .app-table-dropdown__row-header-btn {
    margin-right: -15px;
  }
}
</style>
